import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { Box, ButtonBase } from '@mui/material';
import React from 'react';
import { GlobalContentFooterContext } from '../GlobalContentFooter/GlobalContentFooterContext';
import { globalPinnedBarWidth } from '../GlobalPinnedBar/constants';
import { themeColors } from '../JuvareTheme';
import { useSmallOrMediumDevice } from '../hooks';
export const FullHeightPage = (props) => {
    const smallOrMediumDevice = useSmallOrMediumDevice();
    const { footer } = React.useContext(GlobalContentFooterContext);
    const [pinnedBarOpen, setPinnedBarOpen] = React.useState(false);
    return (React.createElement(React.Fragment, null,
        props.pinnedBarContent != null && (React.createElement(React.Fragment, null,
            React.createElement(Box, { sx: {
                    position: 'absolute',
                    top: 0,
                    bottom: 0,
                    left: smallOrMediumDevice && !pinnedBarOpen ? -globalPinnedBarWidth : 0,
                    width: globalPinnedBarWidth,
                    overflow: 'hidden',
                    bgcolor: 'background.paper',
                    boxShadow: (theme) => theme.shadows[2],
                    transition: (theme) => theme.transitions.create('left'),
                    zIndex: (theme) => theme.zIndex.appBar - 4,
                } }, props.pinnedBarContent),
            smallOrMediumDevice && (React.createElement(ButtonBase, { centerRipple: true, focusRipple: true, sx: {
                    position: 'absolute',
                    boxSizing: 'border-box',
                    top: `50%`,
                    marginTop: '-40px',
                    left: smallOrMediumDevice && pinnedBarOpen ? globalPinnedBarWidth : 0,
                    width: 32,
                    height: 80,
                    borderTopRightRadius: 4,
                    borderBottomRightRadius: 4,
                    overflow: 'hidden',
                    color: themeColors.accent.blue.base,
                    bgcolor: 'background.paper',
                    boxShadow: (theme) => theme.shadows[3],
                    transition: (theme) => theme.transitions.create('left'),
                    zIndex: (theme) => theme.zIndex.appBar - 5,
                }, onClick: () => setPinnedBarOpen(!pinnedBarOpen) }, pinnedBarOpen ? React.createElement(KeyboardArrowLeftIcon, { color: 'inherit' }) : React.createElement(KeyboardArrowRightIcon, { color: 'inherit' }))))),
        React.createElement(Box, { sx: {
                height: '100%',
                paddingLeft: (props.pinnedBarContent != null && (pinnedBarOpen || !smallOrMediumDevice) ? globalPinnedBarWidth : 0) + 'px',
                overflow: props.scrollable ? 'auto' : 'hidden',
                transition: (theme) => theme.transitions.create('padding-left'),
            } }, props.showFooter && footer != null ? (React.createElement(Box, { sx: {
                height: props.scrollable ? undefined : '100%',
                minHeight: props.scrollable ? '100%' : undefined,
                display: 'grid',
                gridTemplateRows: '1fr auto',
                gridTemplateColumns: '100%',
            } },
            React.createElement(Box, { sx: { overflow: props.scrollable ? undefined : 'hidden' } }, props.children),
            React.createElement(Box, null, footer))) : (props.children))));
};
